import { makeStyles } from "@fluentui/react-components";

const useAddCoverageStyles = makeStyles({
    errorCard: {
        marginBottom: "4px",
        paddingLeft: "8px",
        paddingRight: "8px",
    }
});
export default useAddCoverageStyles;